import { content } from './TerminPlanungsstatusCard.content';

export const TermineImPlanungsintervall = () => (
  <>
    {content.fields.termineImPlanungsintervall1}
    <p style={{ margin: 0 }}>{content.fields.termineImPlanungsintervall2}</p>
  </>
);
